import { z } from "zod"

export const loginSchema = z.object({
  email: z.string().trim().min(1, "Введите почту").email("Введите корректный email"),
  password: z.string().min(1, "Введите пароль"),
})

export const forgotPasswordSchema = z.object({
  email: z.string().trim().min(1, "Введите почту").email("Введите корректный email"),
})

export type LoginFormValues = z.infer<typeof loginSchema>
export type LoginFieldErrors = Partial<Record<keyof LoginFormValues, string>>
